import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "../result/result.css";
import { Link } from 'react-router-dom';
// import Sidebar from '../../components/Sidebar';
// import AlertMessage from "../../AlertMessage"; 
import { useParams } from 'react-router-dom';

const WebBoardResult = () => {

    const params = useParams();
    const udiseNumber = params.udiseNumber;
    const srNo = params.srNo;
    const academicYear = params.academicYear;
    const [classValue, setClassValue] = useState(params.classValue || '');
    const [selectedExamName, setSelectedExamName] = useState(params.selectedExamName || '');
    const [division, setDivision] = useState(params.division || ''); // Add setDivision

    const [studentData, setStudentData] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [marksData, setMarksData] = useState({});
    const [classes, setClasses] = useState([]);
    const [selectedStudentResults, setSelectedStudentResults] = useState(null);
    const [showModal, setShowModal] = useState(true);
    const [schoolName, setSchoolName] = useState('');
    const [schoolLogo, setSchoolLogo] = useState('');

    const examNames = ['First Semester', 'Second Semester'];
    const examNameTranslations = {
        "First Semester": "प्रथम सत्र",
        "Second Semester": "द्वितीय सत्र",
    };
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    useEffect(() => {
        if (alertMessage) {
            setShowAlert(true);
            const timeoutId = setTimeout(() => {
                setShowAlert(false);
                setAlertMessage("");
            }, 3000);
            return () => clearTimeout(timeoutId);
        }
    }, [alertMessage]);



    useEffect(() => {
        const fetchDefaultSettings = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
                if (response.ok) {
                    const data = await response.json();

                    // if (data) {
                    //     setAcademicYear(data.defaultYear || "");
                    // }
                } else {
                    console.error("Failed to fetch default settings.");
                }
            } catch (error) {
                console.error("Error fetching default settings:", error);
            }
        };

        fetchDefaultSettings();
    }, [udiseNumber]);

    const [subjectSequence, setSubjectSequence] = useState([]); // New state for subject sequence
    useEffect(() => {
        if (academicYear && classValue && division) {
            fetchSubjectSequence();
            fetchStudentData();
        }
    }, [academicYear, classValue, division]);

    const fetchSubjectSequence = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/${academicYear}/${classValue}.json`
            );
            if (!response.ok) {
                throw new Error('Failed to fetch subject sequence');
            }
            const data = await response.json();
            // Assuming the data is an object with numeric keys
            const orderedSubjects = Object.keys(data)
                .sort((a, b) => parseInt(a) - parseInt(b)) // Sort by numeric keys
                .map((key) => data[key]); // Map keys to subject names
            setSubjectSequence(orderedSubjects);
        } catch (error) {
            console.error('Error fetching subject sequence:', error);
        }
    };


    useEffect(() => {
        const storedLanguage = localStorage.getItem('language') || 'English';
        setLanguage(storedLanguage);
    }, []);


    const fetchSchoolName = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`
            );
            if (!response.ok) {
                throw new Error('Failed to fetch school name');
            }
            const data = await response.json();
            setSchoolName(data.schoolName || 'N/A');
            setSchoolLogo(data.schoolLogo || ''); // Add this line
        } catch (error) {
            console.error('Error fetching school name:', error);
        }
    };
    useEffect(() => {
        fetchSchoolName();
        fetchStudentData();
    }, []);

    useEffect(() => {
        if (selectedExamName && classValue && academicYear && division) {
            fetchMarksForSelectedSubject();
        }
    }, [selectedExamName, classValue, academicYear, division]);

    const handleClassChange = (e) => {
        setClassValue(e.target.value);
        setDivision(''); // Reset division when class changes
    };
    const handleExamNameChange = (e) => {
        setSelectedExamName(e.target.value);
    };

    const filteredExamNames = examNames.filter((examName) => examName === "Second Semester");


    // Define calculateRemark globally
    const calculateRemark = (totalMarks) => {
        if (totalMarks === null || totalMarks === undefined || isNaN(totalMarks)) return '-';
        const passMark = 35; // Assumed Pass Mark Threshold
        if (totalMarks > 100 || totalMarks < 0) return '-'; // Handle potential invalid data
        return totalMarks >= passMark ? 'Pass' : 'Fail';
    };

    // Move fetchStudentData function here
    const fetchStudentData = async () => {
        try {
            const studentInfoResponse = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}.json`
            );
            if (!studentInfoResponse.ok) {
                throw new Error('Failed to fetch student info');
            }
            const studentInfo = await studentInfoResponse.json();

            let processedResults = {};
            let nondiData = {};

            if (selectedExamName) { // Fetch nondi data based on the selected exam name
                const nondiResponse = await fetch(
                    `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}/nondi.json`
                );

                if (nondiResponse.ok) {
                    nondiData = await nondiResponse.json();
                } else {
                    console.warn(`Failed to fetch nondi data for ${selectedExamName}`);
                }
            }

            if (selectedExamName === "Second Semester") {
                const examResponse = await fetch(
                    `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/Second Semester.json`
                );

                if (examResponse.ok) {
                    const semesterData = await examResponse.json();

                    if (semesterData) {
                        for (const subjectName in semesterData) {
                            if (subjectName === "nondi") continue;

                            const subjectData = semesterData[subjectName];
                            const akarikTotal = Number(subjectData?.Akarik?.Total || 0);
                            const sanklikTotal = Number(subjectData?.Sanklik?.Total || 0);
                            const totalMarks = akarikTotal + sanklikTotal;

                            processedResults[subjectName] = {
                                grade: calculateGrade(totalMarks),
                                minMarks: passingMarks, // Use the calculated passing marks
                                totalMarks,
                                remark: calculateRemark(totalMarks),
                                outOf: 100,
                            };
                        }
                    }
                }
            }

            setSelectedStudentResults({
                studentName: studentInfo?.stdName || '',
                stdMother: studentInfo?.stdMother || '',
                stdFather: studentInfo?.stdFather || '',
                stdSurname: studentInfo?.stdSurname || '',
                dob: studentInfo?.dob || '',
                division: studentInfo?.division || '',
                motherTounge: studentInfo?.motherTounge || '',
                studentId: studentInfo?.studentId || '',
                gender: studentInfo?.gender || '',
                rollNo: studentInfo?.rollNo || '',
                results: processedResults,
                nondiData: nondiData, // Store nondi data dynamically
            });
            setShowModal(true);
        } catch (error) {
            console.error("Error fetching student data:", error);
            setSelectedStudentResults({ error: "Failed to load student data." });
            setShowModal(true);
        }
    };

    useEffect(() => {
        // Helper function to calculate Grade based on Total Marks (out of 100)
        const calculateGrade = (totalMarks) => {
            if (totalMarks === null || totalMarks === undefined || isNaN(totalMarks)) return '-';
            const percentage = totalMarks; // Assuming max marks are 100
            if (percentage > 100) return '-'; // Handle potential invalid data
            if (percentage >= 91) return 'A1';
            if (percentage >= 81) return 'A2';
            if (percentage >= 71) return 'B1';
            if (percentage >= 61) return 'B2';
            if (percentage >= 51) return 'C1';
            if (percentage >= 41) return 'C2';
            if (percentage >= 35) return 'D'; // Assumed Pass Mark Threshold
            if (percentage >= 21) return 'E1';
            if (percentage >= 0) return 'E2';
            return '-'; // Default/Error case
        };

        // Define calculateRemark function here
        const calculateRemark = (totalMarks) => {
            if (totalMarks === null || totalMarks === undefined || isNaN(totalMarks)) return '-';
            const passMark = 35; // Assumed Pass Mark Threshold
            if (totalMarks > 100 || totalMarks < 0) return '-'; // Handle potential invalid data
            return totalMarks >= passMark ? 'Pass' : 'Fail';
        };

        const fetchStudentData = async () => {
            try {
                // Fetch basic student info
                const studentInfoResponse = await fetch(
                    `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}.json`
                );
                if (!studentInfoResponse.ok) {
                    throw new Error('Failed to fetch student info');
                }
                const studentInfo = await studentInfoResponse.json();

                let processedResults = {};
                let nondiData = {}; // To store nondi specific data if needed

                // --- Logic specifically for Second Semester ---
                if (selectedExamName === "Second Semester") {
                    const examResponse = await fetch(
                        // Fetch the entire "Second Semester" node for the specific academic year
                        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/Second Semester.json`
                    );

                    if (!examResponse.ok) {
                        // Handle case where Second Semester data might not exist at all
                        console.warn(`Failed to fetch ${selectedExamName} data, maybe no data recorded yet.`);
                        // Set results to empty object or handle as needed
                    } else {
                        const semesterData = await examResponse.json();

                        if (semesterData) { // Check if semesterData is not null
                            // Iterate over subjects within Second Semester data
                            for (const subjectName in semesterData) {
                                if (subjectName === "nondi") {
                                    // Handle 'nondi' data separately
                                    nondiData = semesterData.nondi || {};
                                    continue; // Skip 'nondi' for the main results table
                                }

                                const subjectData = semesterData[subjectName];
                                let akarikTotal = 0;
                                let sanklikTotal = 0;

                                // Safely access Akarik total
                                if (subjectData && subjectData.Akarik && subjectData.Akarik.Total !== undefined && subjectData.Akarik.Total !== null) {
                                    akarikTotal = Number(subjectData.Akarik.Total) || 0;
                                } else {
                                    console.warn(`Akarik total missing or invalid for subject: ${subjectName}`);
                                }


                                // Safely access Sanklik total
                                if (subjectData && subjectData.Sanklik && subjectData.Sanklik.Total !== undefined && subjectData.Sanklik.Total !== null) {
                                    sanklikTotal = Number(subjectData.Sanklik.Total) || 0;
                                } else {
                                    console.warn(`Sanklik total missing or invalid for subject: ${subjectName}`);
                                }


                                const totalMarks = akarikTotal + sanklikTotal;
                                const minMarks = 35; // Fixed Minimum Passing Marks
                                const outOfMarks = 100; // Fixed Total Maximum Marks
                                const grade = calculateGrade(totalMarks);
                                const remark = calculateRemark(totalMarks);

                                processedResults[subjectName] = {
                                    grade: grade,
                                    minMarks: minMarks,
                                    totalMarks: totalMarks,
                                    remark: remark,
                                    outOf: outOfMarks, // Store max marks
                                    // Include raw Akarik/Sanklik if needed for display elsewhere
                                    // akarik: subjectData.Akarik,
                                    // sanklik: subjectData.Sanklik
                                };
                            }
                        } else {
                            console.warn(`${selectedExamName} data node is empty or null.`);
                        }
                    }
                } else {
                    // --- Placeholder for other exam types (First Semester, All Exams etc.) ---
                    // You would need to add or adapt logic here if you want to support
                    // fetching and processing for other exam names based on their specific structures.
                    // The original code had logic for this, which would need review and
                    // potential modification based on the actual structure of those exams in Firebase.
                    console.log(`Processing logic for exam "${selectedExamName}" is not implemented in this specific update.`);
                    // For now, it will just show basic student info without results for other exams.
                }


                console.log("Processed Results:", processedResults);
                console.log("Nondi Data:", nondiData);

                // Update the state with all the necessary data
                setSelectedStudentResults({
                    studentName: studentInfo?.stdName || '',
                    stdMother: studentInfo?.stdMother || '',
                    stdFather: studentInfo?.stdFather || '',
                    stdSurname: studentInfo?.stdSurname || '',
                    dob: studentInfo?.dob || '',
                    division: studentInfo?.division || '',
                    motherTounge: studentInfo?.motherTounge || '',
                    studentId: studentInfo?.studentId || '',
                    gender: studentInfo?.gender || '',
                    rollNo: studentInfo?.rollNo || '',
                    results: processedResults,
                    nondiData: nondiData, // Store nondi data in state
                });
                setShowModal(true); // Ensure modal shows after data fetch

            } catch (error) {
                console.error("Error fetching student data:", error);
                // Optionally, update state to show an error message to the user
                setSelectedStudentResults({ error: "Failed to load student data." });
                setShowModal(true);
            }
        };

        // Trigger fetch only if all necessary parameters are available
        if (udiseNumber && srNo && academicYear && selectedExamName) {
            fetchStudentData();
        } else {
            console.log("Missing parameters, skipping fetch:", { udiseNumber, srNo, academicYear, selectedExamName });
            // Optionally clear previous results or show a message
            setSelectedStudentResults(null); // Clear previous results if params change/missing
            setShowModal(false); // Hide modal if params are missing
        }

        // Add udiseNumber and potentially other params fetched via useParams if they can change
    }, [udiseNumber, srNo, academicYear, selectedExamName, division]); // Dependencies for the effect



    const processStudentData = (data) => {
        const processedData = {};
        if (data) {
            for (const subject in data) {
                if (subject !== 'nondi') {
                    const akarikTotal = data[subject]?.Akarik?.Total || 0;
                    const sanklikTotal = data[subject]?.Sanklik?.Total || 0;
                    processedData[subject] = {
                        ...data[subject],
                        total: akarikTotal + sanklikTotal
                    };
                }
            }
        }
        return processedData;
    };



    // Call fetchStudentData when the component mounts with URL parameters
    useEffect(() => {
        fetchSchoolName();
        if (academicYear && classValue && selectedExamName && srNo) {
            fetchStudentData();
        }
    }, [academicYear, classValue, selectedExamName, srNo]);



    const [divisions, setDivisions] = useState([]); // Add this line

    useEffect(() => {
        if (classValue && studentData && Array.isArray(studentData)) {
            const divisionsForClass = studentData
                .filter(student => student.currentClass === classValue)
                .map(student => student.division)
                .filter((value, index, self) => value && self.indexOf(value) === index);
            setDivisions(divisionsForClass);
        } else {
            setDivisions([]);
        }
    }, [classValue, studentData]);


    const fetchMarksForSelectedSubject = async () => {
        try {
            const selectedStudents = studentData.filter(
                (student) => student.currentClass === classValue && student.division === division
            );
            setSelectedStudents(selectedStudents);
            const marksDataPromises = selectedStudents.map(async (student) => {
                const studentMarks = await fetchMarksData(
                    student.srNo,
                    academicYear,
                    selectedExamName
                );
                return { srNo: student.srNo, marks: studentMarks };
            });

            const marksDataArray = await Promise.all(marksDataPromises);
            const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
                acc[srNo] = marks;
                return acc;
            }, {});

            setMarksData(marksData);
        } catch (error) {
            console.error('Error fetching marks data:', error);
        }
    };

    const fetchMarksData = async (srNo, academicYear, examName) => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${examName}.json`;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Error fetching data: ${response.statusText}`);
            }
            const data = await response.json();
            console.log(`Marks for ${srNo} in ${examName}:`, data); // Updated log to include exam name
            return data || {};
        } catch (error) {
            console.error('Error fetching marks data:', error);
            return {};
        }
    };

    const [selectedStudentForSr, setSelectedStudentForSr] = useState('')


    const viewResult = async (srNo) => {
        try {
            const student = selectedStudents.find((student) => student.srNo === srNo);
            if (!student) {
                throw new Error("Student not found");
            }

            setSelectedStudentForSr(student); // Ensure this is set before fetching attendance data
            console.log("selectedStudentForSr updated:", student);

            // Fetch both first and second semester data
            const firstSemesterResponse = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/First Semester.json`
            );
            const secondSemesterResponse = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}.json`
            );

            if (!firstSemesterResponse.ok || !secondSemesterResponse.ok) {
                throw new Error("Network response was not ok");
            }

            const firstSemesterData = await firstSemesterResponse.json();
            const secondSemesterData = await secondSemesterResponse.json();

            // Check if result data is empty
            if (
                (!firstSemesterData || Object.keys(firstSemesterData).length === 0) &&
                (!secondSemesterData || Object.keys(secondSemesterData).length === 0)
            ) {
                setAlertMessage(
                    "Add the subject and fill the marks to view the result."
                );
                return; // Stop further execution
            }

            console.log("First Semester Data:", firstSemesterData);
            console.log("Second Semester Data:", secondSemesterData);

            const resultsWithTotal = {};

            // Combine all subjects from both semesters
            const allSubjects = new Set([
                ...Object.keys(firstSemesterData),
                ...Object.keys(secondSemesterData),
            ]);

            allSubjects.forEach((subject) => {
                const firstSemesterGrade = firstSemesterData[subject]?.Akarik?.Total
                    ? calculateGrade(
                        firstSemesterData[subject].Akarik.Total +
                        (firstSemesterData[subject].Sanklik?.Total || 0)
                    )
                    : "N/A";

                const akarikTotal =
                    secondSemesterData[subject]?.Akarik?.Total || 0;
                const sankalikTotal =
                    secondSemesterData[subject]?.Sanklik?.Total || 0;
                const total = akarikTotal + sankalikTotal;
                const grade = calculateGrade(total);

                resultsWithTotal[subject] = {
                    akarikTotal,
                    sankalikTotal,
                    total,
                    grade,
                    firstSemesterGrade,
                };
            });

            // Fetch nondi data for both semesters
            const nondiFirstSemesterResponse = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/First Semester/nondi.json`
            );

            const nondiSecondSemesterResponse = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}/nondi.json`
            );

            if (!nondiFirstSemesterResponse.ok || !nondiSecondSemesterResponse.ok) {
                throw new Error("Failed to fetch nondi data");
            }

            const nondiFirstSemesterData = await nondiFirstSemesterResponse.json();
            const nondiSecondSemesterData = await nondiSecondSemesterResponse.json();

            // Set state with both semester data
            setSelectedStudentResults({
                studentName: student.stdName,
                results: resultsWithTotal,
                nondi: nondiSecondSemesterData || {},
                firstSemester: nondiFirstSemesterData || {},
                stdMother: student.stdMother,
                stdFather: student.stdFather,
                stdSurname: student.stdSurname,
                dob: student.dob,
                division: student.division,
                motherTounge: student.motherTounge,
                studentId: student.studentId,
                gender: student.gender,
            });

            setShowModal(true);
        } catch (error) {
            console.error("Error fetching student results:", error);
        }
    };




    const handleGradeChange = (subject, type, value) => {
        setSelectedStudentResults((prevState) => {
            const updatedResults = { ...prevState.results };
            updatedResults[subject][type] = parseInt(value, 10) || 0; // Ensure the value is a number

            return {
                ...prevState,
                results: updatedResults,
            };
        });
    };


    const calculateGradeEnglish = (total) => {
        if (total >= 91) return 'A1';
        if (total >= 81) return 'A2';
        if (total >= 71) return 'B1';
        if (total >= 61) return 'B2';
        if (total >= 51) return 'C1';
        if (total >= 41) return 'C2';
        if (total >= 33) return 'D';
        if (total >= 21) return 'E1';
        return 'E2';
    };

    const calculateGradeMarathi = (total) => {
        if (total >= 91) return 'अ-1';
        if (total >= 81) return 'अ-2';
        if (total >= 71) return 'ब-1';
        if (total >= 61) return 'ब-2';
        if (total >= 51) return 'क-1';
        if (total >= 41) return 'क-2';
        if (total >= 33) return 'ड';
        if (total >= 21) return 'ई-1';
        return 'ई-2';
    };

    // Function to calculate grade based on the current language
    const calculateGrade = (total) => {
        return language === 'English' ? calculateGradeEnglish(total) : calculateGradeMarathi(total);
    };

    const submit = () => {
        // Handle submit logic here
    };
    const handleCloseModal = () => setShowModal(false);

    const months = ['June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'];
    const [attendance, setAttendance] = useState({
        Present: {},
        Absent: {},
        Leave: {}
    });

    // useEffect(() => {
    //     const fetchAttendanceData = async () => {
    //         if (!params.srNo) {
    //             console.warn("fetchAttendanceData skipped: srNo is missing");
    //             return;
    //         }

    //         const currentDate = new Date();
    //         const year = currentDate.getFullYear();
    //         const month = currentDate.toLocaleString('default', { month: 'short' });
    //         const day = currentDate.getDate();

    //         const attendanceData = {
    //             Present: {},
    //             Absent: {},
    //             Leave: {}
    //         };

    //         try {
    //             const response = await fetch(
    //                 `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/Attendance/${params.srNo}/Presenty/${year}/${month}/${day}.json`
    //             );

    //             if (response.ok) {
    //                 const dayData = await response.json();
    //                 console.log(`Attendance Data for ${month} ${day}:`, dayData);

    //                 if (dayData && dayData.present) {
    //                     if (dayData.present === "present") {
    //                         attendanceData.Present[month] = (attendanceData.Present[month] || 0) + 1;
    //                     } else if (dayData.present === "absent") {
    //                         attendanceData.Absent[month] = (attendanceData.Absent[month] || 0) + 1;
    //                     } else if (dayData.present === "leave") {
    //                         attendanceData.Leave[month] = (attendanceData.Leave[month] || 0) + 1;
    //                     }
    //                 }
    //             } else {
    //                 console.warn(`Failed to fetch attendance for ${month} ${day}: ${response.statusText}`);
    //             }

    //             console.log("Final Attendance Data:", attendanceData);
    //             setAttendance(attendanceData);
    //         } catch (error) {
    //             console.error('Error fetching attendance data:', error);
    //         }
    //     };

    //     fetchAttendanceData();
    // }, [params.srNo, udiseNumber, academicYear]);



    useEffect(() => {
        const fetchAttendanceData = async () => {
            if (!params.srNo) {
                console.warn("fetchAttendanceData skipped: srNo is missing");
                return;
            }

            const currentYear = new Date().getFullYear();
            const months = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];

            const daysInMonth = {
                "Jan": 31, "Feb": 28, "Mar": 31, "Apr": 30, "May": 31, "Jun": 30,
                "Jul": 31, "Aug": 31, "Sep": 30, "Oct": 31, "Nov": 30, "Dec": 31
            };

            // Leap year check
            if ((currentYear % 4 === 0 && currentYear % 100 !== 0) || (currentYear % 400 === 0)) {
                daysInMonth["Feb"] = 29;
            }

            const attendanceData = {
                Present: {},
                Absent: {},
                Leave: {}
            };

            try {
                for (const month of months) {
                    const promises = [];
                    for (let day = 1; day <= daysInMonth[month]; day++) {
                        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/Attendance/${params.srNo}/Presenty/${currentYear}/${month}/${day}.json`;
                        promises.push(fetch(url).then(res => res.ok ? res.json() : null));
                    }

                    const results = await Promise.all(promises);

                    results.forEach((dayData, index) => {
                        if (dayData && dayData.present) {
                            const day = index + 1; // Since index starts from 0
                            if (dayData.present === "present") {
                                attendanceData.Present[month] = (attendanceData.Present[month] || 0) + 1;
                            } else if (dayData.present === "absent") {
                                attendanceData.Absent[month] = (attendanceData.Absent[month] || 0) + 1;
                            } else if (dayData.present === "leave") {
                                attendanceData.Leave[month] = (attendanceData.Leave[month] || 0) + 1;
                            }
                        }
                    });
                }

                console.log("Final Attendance Data for the Year:", attendanceData);
                setAttendance(attendanceData);
            } catch (error) {
                console.error('Error fetching attendance data:', error);
            }
        };

        fetchAttendanceData();
    }, [params.srNo, udiseNumber, academicYear]);



    const [summerVacationDate, setSummerVacationDate] = useState('');
    const [winterVacationDate, setWinterVacationDate] = useState('');

    // Define the English month names
    const firstSemesterMonths = ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov'];
    const secondSemesterMonths = ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May'];

    // Function to translate month to Marathi if needed
    const getMonthName = (month) => {
        const marathiMonths = {
            June: 'जून', July: 'जुलै', Aug: 'ऑगस्ट', Sep: 'सप्टेंबर', Oct: 'ऑक्टोबर', Nov: 'नोव्हेंबर',
            Dec: 'डिसेंबर', Jan: 'जानेवारी', Feb: 'फेब्रुवारी', Mar: 'मार्च', Apr: 'एप्रिल', May: 'मे'
        };
        return language === "English" ? month : marathiMonths[month];
    };

    const getAttendanceType = (type) => {
        const marathiTypes = {
            Present: 'उपस्थित',
            Absent: 'गैरहजर',
            Leave: 'रजा'
        };
        return language === "English" ? type : marathiTypes[type];
    };


    //  setting marks to pass 
    const getPassingMarks = (currentClass) => {
        if (selectedStudentForSr.currentClass === "Class V" || selectedStudentForSr.currentClass === "इयत्ता पाचवी") {
            return 18;
        } else if (selectedStudentForSr.currentClass === "Class VIII" || selectedStudentForSr.currentClass === "इयत्ता आठवी") {
            return 21;
        }
        // Default passing marks if none of the specified classes are selected
        return 18;
    };

    const passingMarks = getPassingMarks(selectedStudentForSr.currentClass);

    //percentage 
    let totalSubjects = 0;
    let totalMarks = 0;
    let percentage = 0;

    if (selectedStudentResults && selectedStudentResults.results) {
        totalSubjects = Object.entries(selectedStudentResults.results)
            .filter(([subject]) => subject !== "nondi").length;

        totalMarks = Object.entries(selectedStudentResults.results)
            .filter(([subject]) => subject !== "nondi")
            .reduce((acc, [subject, grades]) => acc + (grades.totalMarks || 0), 0); // Use totalMarks from grades

        percentage = totalSubjects > 0 ? (totalMarks / (totalSubjects * 100)) * 100 : 0; // Calculate percentage
    }

    // Re-Exam
    const currentClass = selectedStudentResults?.currentClass; // Example: "Class V" or "Class VIII"
    const hasFailed = selectedStudentResults?.results &&
        Object.values(selectedStudentResults.results).some(grades => (grades.sankalikTotal || 0) + (grades.akarikTotal || 0) < passingMarks);

    // Add "Re-Exam" if the student is in Class V or VIII and has failed
    let examOptions = [...filteredExamNames];
    if ((currentClass === "Class V" || currentClass === "Class VIII") && hasFailed) {
        examOptions.push("Re-Exam");
    }

    const handlePrint = () => {
        const printContent = document.querySelector('.modal-body'); // Select the modal body content

        if (printContent) {
            const printWindow = window.open('', '', 'height=600,width=800');
            printWindow.document.write(`
        <html>
          <head>
            <title>Print Student Report</title>
            <style>
             @page {
                size: A4 Landscape; /* auto is the initial value */
              margin: 3mm; /* this affects the margin in the printer settings */
            }
              body {
                font-family: 'Poppins', sans-serif;
                margin: 0;
                padding: 0;
                color: black;
              }
  
              .container {
                width: 297mm;
                height: 200mm;
                margin: 0 auto;
                box-sizing: border-box;
                padding: 3mm;
                border: 3px solid #0e0303;
                overflow: hidden;
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
              }
  .gradient-background {
  background: linear-gradient(to bottom, rgb(240, 217, 228), rgb(245, 255, 255), rgb(250, 230, 240));
}
              .left, .right {
                width: 48%;
                border: 2px solid black;
                padding: 10px;
                box-sizing: border-box;
              }
  .gradable{
  position: absolute; /* add this */
  bottom: 2px; /* add this */
  left: 1%; /* add this */
  width: 98%; /* add this */
}
           


.grad{
  position: absolute; /* add this */
  bottom: 0; /* add this */
  left: 20px; /* add this */
  width: 100%; /* add this */
}


  
              .left-box {
                background-color: #f9f9f9;
                padding: 20px;
                border: 1px solid #ddd;
                border-radius: 10px;
              }
  
              .school-info {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
              }
  
              .school-info img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                margin-right: 20px;
              }
  
              .school-info h2 {
                font-size: 18px;
                font-weight: bold;
                margin: 0;
              }
  
              .student-info {
                margin-top: 20px;
              }
  
              .student-info h3 {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 10px;
              }
  
              .student-info ul {
                list-style: none;
                padding: 0;
                margin: 0;
              }
  
              .student-info li {
                margin-bottom: 10px;
              }
  
              .student-info label {
                font-weight: bold;
                margin-right: 10px;
              }
  
              .student-info span {
                font-size: 14px;
                color: #666;
              }
  
              .student-info-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 20px;
                background-color: #f9f9f9;
                padding: 20px;
                border-radius: 10px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              }
  
              .student-info-grid section {
                background-color: #ffffff;
                padding: 15px;
                border-radius: 8px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
              }
  
              .student-info-grid h2 {
                font-size: 1em;
                margin-bottom: 10px;
                color: #333;
                border-bottom: 2px solid #ddd;
                padding-bottom: 5px;
              }
  
              .student-info-grid p {
                margin: 1px 0;
                font-size: 0.9em;
              }
  
              .student-info-grid label {
                font-weight: bold;
                color: #555;
              }
  
              .student-info-grid span {
                margin-left: 5px;
                color: #666;
              }
  
              .student-info-grid p:last-child {
                margin-bottom: 0;
              }
  
              .left {
                border: 2px solid #0f0202;
                padding: 20px;
                position: relative;
              }
  
              .right {
                position: relative;
                width: 48% !important;
                border: 2px solid #0e0101;
                padding: 10px;
                overflow: hidden;
              }
  
              /* Table styles */
              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
              }
  
              th, td {
                border: 1px solid #130606;
                padding: 5px;
                text-align: left;
                word-wrap: break-word;
                box-sizing: border-box;
              }
  
              .table-striped tbody tr:nth-of-type(odd) {
                background-color: rgba(0, 0, 0, 0.05); /* Stripe effect */
              }
  
              .table-bordered {
                border: 1px solid #130606;
              }
  
             .grade-table {
  margin-top: 20px;
}

.grade-table table {
  width: 100%;
  border-collapse: collapse;
}

.grade-table th, .grade-table td {
  border: 1px solid #ccc;
  padding: 5px;
  text-align: center;
  box-sizing: border-box;
}

.grade-table thead th {
  background-color: #f4f4f4;
}

.grade-table tbody td {
  text-align: center;
}
  
              .attendance-table th, .attendance-table td {
                width: 33%;
              }
                /* General Table Styles */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px; /* Adds space above the table */
}

thead {
  background-color: #f2f2f2; /* Light grey background for header */
}

th, td {
  border: 1px solid #ddd; /* Light grey border */
  padding: 8px; /* Space within cells */
  text-align: left; /* Align text to the left */
}

th {
  background-color: #f4f4f4; /* Slightly darker grey background for header cells */
  font-weight: bold; /* Bold text in header */
}

input[type="text"] {
  width: 100%; /* Full width of cell */
  box-sizing: border-box; /* Include padding and border in element's total width and height */
  border: 1px solid #ccc; /* Light grey border for input */
  padding: 4px; /* Space inside input field */
  font-size: 14px; /* Text size inside input */
}

input[type="text"]:focus {
  outline: none; /* Remove default focus outline */
  border-color: #8A1538; /* Border color on focus */
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25); /* Shadow effect on focus */
}

/* Zebra striping for table rows */
tbody tr:nth-child(odd) {
  background-color: #fafafa; /* Light grey background for odd rows */
}
  
              /* Ensure the right container does not overflow */
              .right {
                overflow: hidden; /* Clipping any content that exceeds the container bounds */
              }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
          </body>
        </html>
      `);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
        } else {
            console.error('Print content not found');
        }
    };

    const fetchSubjectsForClass = async (classValue) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjects/${academicYear}/${classValue}.json`
            );
            if (!response.ok) {
                throw new Error('Failed to fetch subjects for class');
            }
            const data = await response.json();
            setClasses(data || []);
        } catch (error) {
            console.error('Error fetching subjects for class:', error);
        }
    };

    const calculateTotalMarks = (data) => {
        const subjects = Object.keys(data).filter(subject => subject !== 'nondi');
        const totals = subjects.map(subject => {
            const akarikTotal = data[subject]?.Akarik?.Total || 0;
            const sanklikTotal = data[subject]?.Sanklik?.Total || 0;
            return {
                subject,
                total: akarikTotal + sanklikTotal
            };
        });
        return totals;
    };

    useEffect(() => {
        const fetchAndCalculateMarks = async () => {
            try {
                // Replace with the correct path to the result file
                const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/path/to/result.json`);

                if (!response.ok) {
                    throw new Error(`Failed to fetch data: ${response.statusText}`);
                }

                let data;
                try {
                    data = await response.json();
                } catch (jsonError) {
                    console.error('Error parsing JSON:', jsonError);
                    return; // Exit the function if JSON parsing fails
                }

                if (!data || typeof data !== 'object') {
                    console.warn('No valid data found in the response.');
                    return;
                }

                const firstSemesterData = data['First Semester'] || {};
                const secondSemesterData = data['Second Semester'] || {};

                const firstSemesterTotals = calculateTotalMarks(firstSemesterData);
                const secondSemesterTotals = calculateTotalMarks(secondSemesterData);

                console.log('First Semester Totals:', firstSemesterTotals);
                console.log('Second Semester Totals:', secondSemesterTotals);
            } catch (error) {
                console.error('Error fetching or calculating marks:', error);
            }
        };

        fetchAndCalculateMarks();
    }, []);

    useEffect(() => {
        if (academicYear && classValue && selectedExamName && srNo && division) {
            fetchStudentData();
        }
    }, [academicYear, classValue, selectedExamName, srNo, division]);

    return (
        <div>
            {/* <AlertMessage message={alertMessage} show={showAlert} /> */}

            {/* <Sidebar /> */}
            <div className=' main-content-of-page'>
                <h3 style={{ color: 'rgb(27, 67, 50)', textAlign: 'center' }}>  {language === "English" ? "Board Exam Result " : " बोर्ड परीक्षेचा निकाल"}</h3>
                {/* <table className="table table-striped table-bordered">
                    <tbody>
                        <tr>
                            <th> {language === "English" ? "Academic Year " : "शैक्षणिक वर्ष"}</th>
                            <td>
                                <select id="academicYear" value={academicYear} onChange={handleAcademicYearChange} className="form-control custom-select"
                                >
                                    <option >{language === "English" ? "Select Year " : "वर्ष निवडा"}</option>
                                    <option value="2023-2024" >2023-2024</option>
                                    <option value="2024-2025" >2024-2025</option>
                                    <option value="2025-2026">2025-2026</option>
                                    <option value="2026-2027">2026-2027</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th> {language === "English" ? "Class " : "वर्ग"}</th>
                            <td>
                                <select
                                    id="class"
                                    value={classValue}
                                    onChange={handleClassChange}
                                    className="form-control custom-select"
                                    defaultValue={examNames[0]}
                                >
                                    <option value="">{language === "English" ? "Select Class " : "वर्ग निवडा"}</option>
                                    {classes
                                        .filter(cls => cls === 'Class V' || cls === 'Class VIII' || cls === 'इयत्ता पाचवी' || cls === 'इयत्ता आठवी') // Filter to include only classes 5 and 8
                                        .map((cls, index) => (
                                            <option key={index} value={cls}>
                                                {cls}
                                            </option>
                                        ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>{language === "English" ? "Exam Name " : "परीक्षेचे नाव"}</th>
                            <td>
                                <select
                                    id="examName"
                                    value={selectedExamName}
                                    onChange={handleExamNameChange}
                                    className="form-control custom-select"
                                >
                                    <option value="">{language === "English" ? "Select Exam " : "परीक्षा निवडा"}</option>
                                    {examOptions.map((examName, index) => (
                                        <option key={index} value={examName}>
                                            {language === "English" ? examName : examNameTranslations[examName]}
                                        </option>
                                    ))}
                                </select>

                            </td>
                        </tr>
                    </tbody>
                </table> */}

                {/* <Link to="/failed">
                    {language === "English" ? (
                        <button className="btn btn-primary">Go to Re-Exam Page</button>
                    ) : (
                        <button className="btn btn-primary">पुनर परिषा</button>
                    )}
                </Link> */}
                {selectedStudents.length > 0 && (
                    <div className="mt-4">
                        <table className="table table-striped table-bordered custom-table">
                            <thead>
                                <tr>
                                    <th className="custom-width">{language === "English" ? "Register No " : "रजिस्टर नंबर"}</th>
                                    <th>{language === "English" ? "Student Name " : "विद्यार्थ्याचे नाव"}</th>
                                    <th>{language === "English" ? "Result " : "प्रगतीपत्रक"}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedStudents.map((student) => (
                                    <tr key={student.srNo}>
                                        <td>{student.srNo}</td>
                                        <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                                        <td>
                                            <button className="btn btn-primary" onClick={() => viewResult(student.srNo)}>
                                                {language === "English" ? "View Result" : "प्रगति पत्रक"}
                                            </button>

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                <Modal show={showModal} onHide={handleCloseModal} dialogClassName='modal-80w'>
                
                    <Modal.Body>

                        <div>
                            {/* Second semester modal content */}

                            <div className="container  " style={{
                                background: `linear-gradient(to bottom, rgb(240, 217, 228), rgb(245, 255, 255), rgb(250, 230, 240))`
                            }} >
                                <div className="left">
                                    <div className="left-box">
                                        <div className="school-info">
                                            {schoolLogo && (
                                                <div>
                                                    <img src={schoolLogo} alt={`$Logo`} />
                                                </div>
                                            )}
                                            <h2>{schoolName}</h2>
                                        </div>
                                    </div>
                                    <br />

                                    <div class="student-info-grid">
                                        <p>
                                            <label>{language === "English" ? "Student Name:" : "विद्यार्थ्याचे नाव"}</label>
                                            <span>
                                                {selectedStudentResults?.studentName || 'N/A'}{' '}
                                                {selectedStudentResults?.stdFather || 'N/A'}{' '}
                                                {selectedStudentResults?.stdSurname || 'N/A'}
                                            </span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Roll No:" : "हजेरी क्रमांक"}</label>
                                            <span>{selectedStudentResults?.rollNo || 'N/A'}</span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Exam:" : "परीक्षा"}</label>
                                            <span>{selectedExamName || 'N/A'}</span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Academic Year:" : "शैक्षणिक वर्ष:"}</label>
                                            <span>{academicYear || 'N/A'}</span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Class:" : "वर्ग"}</label>
                                            <span>{classValue || 'N/A'} {division || '-'}</span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Mother Name:" : "आईचे नाव"}</label>
                                            <span>{selectedStudentResults?.stdMother || 'N/A'}</span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Date Of Birth:" : "जन्मतारीख"}</label>
                                            <span>{selectedStudentResults?.dob ? selectedStudentResults.dob.split('-').reverse().join('-') : 'N/A'}</span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Division:" : "तुकडी"}</label>
                                            {/* <span>{selectedStudentResults?.division || 'N/A'}</span> */}
                                            <span> {division || '-'}</span>

                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Mother Tongue:" : "मातृभाषा"}</label>
                                            <span>{selectedStudentResults?.motherTounge || 'N/A'}</span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Student ID:" : "विद्यार्थी आयडी"}</label>
                                            <span>{selectedStudentResults?.studentId || 'N/A'}</span>
                                        </p>
                                        <p>
                                            <label>{language === "English" ? "Gender:" : "लिंग"}</label>
                                            <span>{selectedStudentResults?.gender || 'N/A'}</span>
                                        </p>
                                    </div>
                                    <div className="gradable" >
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th rowspan="2">विषय</th>
                                                    <th colspan="2">प्रथम सत्र</th>
                                                    <th colspan="2">द्वितीय सत्र</th>
                                                </tr>
                                                <tr>
                                                    <th>Kg</th>
                                                    <th>Cm</th>
                                                    <th>Kg</th>
                                                    <th>Cm</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>वजन</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>उंची</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="right">
                                    {/* First Semester Attendance Table */}
                                    <h3>{language === "English" ? "Attendance:" : "हजेरी"}</h3>
                                    <h5 style={{ marginTop: '10px' }}>{language === "English" ? "First Semester Attendance:" : "प्रथम सत्राची हजेरी:"}</h5>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>{language === "English" ? "Type:" : "प्रकार"}</th>
                                                {firstSemesterMonths.map((month, index) => (
                                                    <th key={index}>{getMonthName(month)}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {['Present', 'Absent', 'Leave'].map((type) => (
                                                <tr key={type}>
                                                    <td>{getAttendanceType(type)}</td>
                                                    {firstSemesterMonths.map((month, index) => (
                                                        <td key={index}>
                                                            <input
                                                                type="text"
                                                                value={attendance[type][month] || 0}
                                                                readOnly
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Second Semester Attendance Table */}
                                    <h5 style={{ marginTop: '10px' }}>{language === "English" ? "Second Semester Attendance:" : "द्वितीय सत्राची हजेरी:"}</h5>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>{language === "English" ? "Type:" : "प्रकार"}</th>
                                                {secondSemesterMonths.map((month, index) => (
                                                    <th key={index}>{getMonthName(month)}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {['Present', 'Absent', 'Leave'].map((type) => (
                                                <tr key={type}>
                                                    <td>{getAttendanceType(type)}</td>
                                                    {secondSemesterMonths.map((month, index) => (
                                                        <td key={index}>
                                                            <input
                                                                type="text"
                                                                value={attendance[type][month] || 0}
                                                                readOnly
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="grad">
                                        <p>
                                            {language === "English" ? " Instructions for parents:" : "पालकांसाठी सूचना"}
                                            <li>  {language === "English" ? " Students should wear school uniform every day." : "विद्यार्थ्यांनी दररोज शालेय गणवेश परिधान करावा."}</li>
                                            <li> {language === "English" ? "  A student should do the study given in school every day." : "विद्यार्थ्याने शाळेत दिलेला अभ्यास दररोज करावा."}</li>
                                            <li> {language === "English" ? " Students should attend school on time and regularly every day." : "विद्यार्थ्यांनी दररोज वेळेवर व नियमितपणे शाळेत हजर राहावे."}</li>
                                            <li> {language === "English" ? " Students should not carry valuables, money. " : "विद्यार्थ्यांनी मौल्यवान वस्तू, पैसे घेऊन जाऊ नये."}</li>
                                            <li>  {language === "English" ? " Students should follow the rules and discipline of the school. " : "विद्यार्थ्यांनी शाळेचे नियम व शिस्तीचे पालन करावे."}</li>
                                        </p>
                                    </div>
                                    <p style={{ marginTop: '70px', marginLeft: '350px' }}>{language === "English" ? "Parents Signature " : "पालकांची सही"}</p>

                                </div>
                            </div>


                            <div className="container mt-1" style={{ background: `linear-gradient(to bottom, rgb(240, 217, 228), rgb(245, 255, 255), rgb(250, 230, 240))` }}>
                                <div className="left"   >
                                    <h3>{language === "English" ? "Student Progress Report " : "विद्यार्थी प्रगती अहवाल"}</h3>
                                    <div>
                                        <label htmlFor="roll-no">{language === "English" ? "Roll No: " : "हजेरी क्रमांक"}</label>
                                        <span>{selectedStudentResults?.studentName || 'N/A'}</span>
                                    </div>
                                    <div>
                                        <label htmlFor="student-name">{language === "English" ? "Student Name: " : "विद्यार्थ्याचे नाव"}</label>
                                        <span>{selectedStudentResults?.studentName || 'N/A'} {selectedStudentResults?.stdFather || 'N/A'} {selectedStudentResults?.stdSurname || 'N/A'}</span>
                                    </div>
                                    <div>
                                        <label htmlFor="class">{language === "English" ? "Class: " : "वर्ग"}</label>
                                        <span>{classValue || 'N/A'}</span>
                                    </div>

                                    <div>
                                        <label htmlFor="exam-roll-no">{language === "English" ? "Exam : " : "परीक्षा स्त्र"}</label>
                                        <span>{selectedExamName || 'N/A'}</span>
                                    </div>

                                    {selectedStudentResults?.results ? (
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th colSpan="2">{language === "English" ? "First Semester" : "पहिला सत्र"}</th>
                                                    <th colSpan="3">{language === "English" ? "Second Semester" : "दुसरा सत्र"}</th>
                                                </tr>
                                                <tr>
                                                    <th>{language === "English" ? "Subject" : "विषय"}</th>
                                                    <th>{language === "English" ? "Grade" : "गुण"}</th>
                                                    <th>{language === "English" ? "Min. Mark" : "किमान गुण"}</th>
                                                    <th>{language === "English" ? "Total Marks" : "एकूण गुण"}</th>
                                                    <th>{language === "English" ? "Remark" : "शेरा"}</th>
                                                </tr>
                                            </thead>
                                            <tbody>





                                                {selectedStudentResults && selectedStudentResults.results ? (
                                                    subjectSequence
                                                        .filter((subject) => subject in selectedStudentResults.results) // Ensure subjects exist in the results
                                                        .map((subject) => {
                                                            const grades = selectedStudentResults.results[subject];
                                                            return (
                                                                <tr key={subject}>
                                                                    <td><b>{subject}</b></td>
                                                                    <td><b>{grades.grade || 'N/A'}</b></td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={grades.minMarks || 35} // Default to 35 if minMarks is not set
                                                                            readOnly
                                                                            style={{ textAlign: "center" }}
                                                                            className="form-control"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            value={grades.totalMarks || 0} // Default to 0 if totalMarks is not set
                                                                            readOnly
                                                                            className="form-control"
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <b>{grades.remark}</b>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5">{language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}</td>
                                                    </tr>
                                                )}










                                                {selectedStudentResults && selectedStudentResults.results && (
                                                    <>

                                                        <tr>
                                                            <td colSpan="1"></td>
                                                            <td colSpan="2"><b>{language === "English" ? "Total Marks" : "एकूण गुण"}</b></td>
                                                            <td colSpan="1"><b>{totalMarks} / {totalSubjects * 100}</b></td>
                                                            <td colSpan="1"><b>{percentage.toFixed(2)}%</b></td>
                                                        </tr>
                                                    </>
                                                )}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <p>{language === "English" ? "No results available. " : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}</p>
                                    )}
                                    <div>
                                    </div>
                                    <div className="grad" style={{ display: 'flex', alignItems: 'center' }}>
                                        <label style={{ marginRight: '20px', marginBottom: '2px', marginLeft: '20px' }} htmlFor="class-teacher">{language === "English" ? "Class Teacher" : "वर्गशिक्षक"}</label>
                                        <label style={{ marginRight: '20px', marginBottom: '2px', marginLeft: '45%' }} htmlFor="principal">{language === "English" ? "Principal " : "प्राचार्य"}</label>
                                    </div>
                                </div>
                                <div className="right">
                                    <h3 style={{ textAlign: "center", color: "black", fontFamily: "Arial, sans-serif", fontWeight: "bold", marginBottom: "20px" }}>
                                        {language === "English" ? "Nondi " : "नोंदी"}
                                    </h3>

                                    <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "Arial, sans-serif" }}>

                                        <thead>
                                            <tr style={{ color: "black", textAlign: "center" }}>
                                                <th colSpan="" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "First Semester " : "पहिली सत्र"} </th>
                                                <th colSpan="" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "Second Semester " : "दुसरी सत्र"} </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr style={{ color: "black", textAlign: "center" }}>
                                                <th colSpan="2" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "Special Progress" : "विशेष प्रगती"}</th>

                                            </tr>
                                            <tr style={{ backgroundColor: "#ffffff" }}>
                                                <td style={{ width: "50%", padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                                    <textarea
                                                        id="special-progress"
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            borderRadius: "4px",
                                                            border: "1px solid #ccc",
                                                            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                                            resize: "none",
                                                            fontSize: "14px",
                                                            height: "100px"
                                                        }}
                                                        value={selectedStudentResults?.firstSemester?.specialEntries || "No data available"}
                                                        readOnly
                                                    />
                                                </td>

                                                <td style={{ width: "50%", padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                                    <textarea
                                                        id="special-progress"
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            borderRadius: "4px",
                                                            border: "1px solid #ccc",
                                                            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                                            resize: "none",
                                                            fontSize: "14px",
                                                            height: "100px"
                                                        }}
                                                        value={selectedStudentResults?.nondiData?.specialEntries || "No data available"}
                                                        readOnly
                                                    />
                                                </td>
                                            </tr>
                                            <tr style={{ color: "black", textAlign: "center" }}>
                                                <th colSpan="2" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "Hobbies" : "छंद"}</th>
                                            </tr>
                                            <tr style={{ backgroundColor: "#ffffff" }}>
                                                <td style={{ width: "33%", padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                                    <textarea
                                                        id="special-progress"
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            borderRadius: "4px",
                                                            border: "1px solid #ccc",
                                                            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                                            resize: "none",
                                                            fontSize: "14px",
                                                            height: "100px"
                                                        }}
                                                        value={selectedStudentResults?.firstSemester?.interestsAndHobbies || "No data available"}
                                                        readOnly />
                                                </td>
                                                <td style={{ padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                                    <textarea
                                                        id="hobbies"
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            borderRadius: "4px",
                                                            border: "1px solid #ccc",
                                                            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                                            resize: "none",
                                                            fontSize: "14px",
                                                            height: "100px"
                                                        }}
                                                        value={selectedStudentResults?.nondiData?.interestsAndHobbies || "No data available"}
                                                        readOnly
                                                    />
                                                </td>

                                            </tr>
                                            <tr style={{ color: "black", textAlign: "center" }}>
                                                <th colSpan="2" style={{ padding: "2px", border: "1px solid #ddd", fontSize: "16px" }}>{language === "English" ? "Required Improvements" : "आवश्यक सुधारणा"}</th>
                                            </tr>
                                            <tr style={{ backgroundColor: "#ffffff" }}>
                                                <td style={{ width: "33%", padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                                    <textarea
                                                        id="special-progress"
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            borderRadius: "4px",
                                                            border: "1px solid #ccc",
                                                            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                                            resize: "none",
                                                            fontSize: "14px",
                                                            height: "100px"
                                                        }}
                                                        value={selectedStudentResults?.firstSemester?.necessaryCorrections || "No data available"}
                                                        readonly />
                                                </td>
                                                <td style={{ padding: "2px", border: "1px solid #ddd", verticalAlign: "top" }}>
                                                    <textarea
                                                        id="improvements"
                                                        style={{
                                                            width: "100%",
                                                            padding: "10px",
                                                            borderRadius: "4px",
                                                            border: "1px solid #ccc",
                                                            boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                                                            resize: "none",
                                                            fontSize: "14px",
                                                            height: "100px"
                                                        }}
                                                        value={selectedStudentResults?.nondiData?.necessaryCorrections || "No data available"}
                                                        readOnly
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="grade-table" >
                                        <h3>{language === "English" ? "Grade Table" : "श्रेणी टेबल"}</h3>
                                        <table >
                                            <thead>
                                                <tr>
                                                    <th>{language === "English" ? "A1" : "अ1"}</th>
                                                    <th>{language === "English" ? "A2" : "अ2"}</th>
                                                    <th>{language === "English" ? "B1" : "ब1"}</th>
                                                    <th>{language === "English" ? "B2" : "ब2"}</th>
                                                    <th>{language === "English" ? "C1" : "क1"}</th>
                                                    <th>{language === "English" ? "C2" : "क2"}</th>
                                                    <th>{language === "English" ? "D" : "ड"}</th>
                                                    <th>{language === "English" ? "E1" : "ई1"}</th>
                                                    <th>{language === "English" ? "E2" : "ई2"}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>91% ते 100%</td>
                                                    <td>81% ते 90%</td>
                                                    <td>71% ते 80%</td>
                                                    <td>61% ते 70%</td>
                                                    <td>51% ते 60%</td>
                                                    <td>41% ते 50%</td>
                                                    <td>33% ते 40%</td>
                                                    <td>21% ते 32%</td>
                                                    <td>20% पेक्षा कमी</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>

                
                </Modal>

            </div>

        </div>
    );
};

export default WebBoardResult;
